import React, { useState } from 'react';
import './Rebates.scss';
import CustomDropZone from './customDropZone';
import PreviewSubmission from './previewSubmission';

function SubmissionForm(page) {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    paypalemail: '',
    agreeToTerms: false,
  });
  let pageData = page.page
  const rebatesData = pageData.components.find((component) => component.block_type === 'Rebates');
  
  const [selectedButton, setSelectedButton] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);

    if (buttonName !== 'PayPal') {
      setFormData({
        ...formData,
        paypalemail: '',
      });
    }
  };

 const handleEdit = (e) => {
   setShowForm(true)
   setShowPreview(false)
 }

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { fullName, email, paypalemail, agreeToTerms } = formData;
    if (fullName && email && agreeToTerms && (selectedButton === 'PayPal' ? paypalemail : true)) {
      setShowForm(false);
      setShowPreview(true);
      if (showForm){
        const targetDiv = document.getElementById('top-of-form');
          if (targetDiv) {
            targetDiv.scrollIntoView({ behavior: 'smooth' });
          }
    
      }
    }
    console.log('Submitted Data:', { fullName, email, paypalemail, agreeToTerms });

  };

  const handleSubmitReceiptClick = (e) => {
    e.preventDefault();
    setShowForm(true);
    if (showForm){
      const targetDiv = document.getElementById('top-of-form');
        if (targetDiv) {
          targetDiv.scrollIntoView({ behavior: 'smooth' });
        }
  
    }
  };

  const handleFileUpload = (files) => {
    setUploadedFiles(files);
  };

  const expirationDate = new Date(rebatesData.expiration_date);
const formattedDate = (expirationDate.getMonth() + 1) + '/' + (expirationDate.getDate() +1) + '/' + expirationDate.getFullYear();


  return (
    <>
      <div className='claim-your-rebate-header'>
        <h1 style={{ margin: '0px', marginTop: '15px' }}>CLAIM YOUR REBATE</h1>
      </div>
      <div className='submission-form-container'>
        <div className='image-column-container'>
          <div className='left-column-image-container'>
            <img src={rebatesData.image} alt="Coors Light" />
          </div>
        </div>
        <div className='left-column-image-text'>
          <div className='save-header'>
            {rebatesData.header}
          </div>
          <div className='save-subheader'>
            {rebatesData.subheader}
          </div>
          <div className='expiration-date'>
            Expires {formattedDate}
          </div>
          <div id="submit-receipt-container">
            <button id="submit-receipt" onClick={handleSubmitReceiptClick}>
              SUBMIT RECEIPT
            </button>
          </div>
          <div className='left-column-disclaimer'>
            {rebatesData.terms_and_conditions}
          </div>
        </div>
      </div>
      {showForm && (
        <div className='submission-form-container'>
          <div className='submission-form-column-right'>
            <div className='submission-form-header'>
              <h2 id="top-of-form">SUBMISSION INFORMATION</h2>
              <div className='mail-in-text'>
                Mail in option: Fill out the form online and print it
              </div>
              <div className='submission-form-header-subtext'>
                *You will need a printer, stamped envelope, and any additional items as required in the terms and conditions
              </div>
            </div>
            <div className="container mt-5 with-spacing">
              <form onSubmit={handleSubmit}>
                <div className="mb-3 label-left with-spacing">
                  <label htmlFor="fullName" className="form-label rebates-form-label">Full Name <span className='red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    id="fullName"
                    placeholder="Enter your full name"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3 label-left">
                  <label htmlFor="email" className="form-label">Email <span className='red'>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className='with-spacing'>
                  <h3 className='product-upc'>PAYMENT METHOD</h3>
                  <p className='product-upc-desc'>How would you like to receive your rebate?</p>
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <button
                          className={`btn btn-primary rebates-custom-button ${selectedButton === 'PayPal' ? 'selected-button' : ''}`}
                          onClick={() => handleButtonClick('PayPal')}
                        >
                          PayPal
                        </button>
                      </div>
                      <div className="col">
                        <button
                          className={`btn btn-primary rebates-custom-button ${selectedButton === 'Venmo' ? 'selected-button' : ''}`}
                          onClick={() => handleButtonClick('Venmo')}
                        >
                          Venmo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {selectedButton === "PayPal" && (
                  <div className="mb-3 label-left" style={{ marginTop: '10px' }}>
                    <label htmlFor="paypal-email" className="form-label" style={{ padding: '5px' }}>
                      <strong>PayPal Email <span className='red'>*</span></strong>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="paypalemail"
                      placeholder="Enter your PayPal account email address"
                      value={formData.paypalemail}
                      onChange={handleChange}
                      required
                    />
                  </div>
                )}
                <div className='with-spacing'>
                  <h3 className='product-upc'>RECEIPT UPLOAD</h3>
                  <CustomDropZone onFileUpload={handleFileUpload} />
                </div>
                <div className="row col with-spacing">
                  <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="agreeToTerms"
                      onChange={handleChange}
                      required
                    />
                    <label className="form-check-label" htmlFor="agreeToTerms">
                      I agree to the <a href="#">Terms and Conditions</a> and to receive emails that are relevant to my rebate.<span className='red'>*</span>
                    </label>
                  </div>
                </div>
                <div className='with-spacing'></div>
                <div className='button-container'>
                  <button type="button" className="half-width">CANCEL</button>
                  <button type="submit" className="half-width" id='review-button' onClick={() => handleSubmit}>REVIEW & SUBMIT</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {showPreview && <PreviewSubmission page={pageData} formData={formData} edit={handleEdit} uploadedFiles={uploadedFiles} paymentMethod={selectedButton} />}
    </>
  );
}

export default SubmissionForm;
